import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import http from '../lib/http';

const GoogleCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const [error, setError] = useState('');

    useEffect(() => {
        const handleGoogleCallback = async () => {
            const params = new URLSearchParams(location.search);
            const code = params.get('code');
            const state = params.get('state');
            const errorParam = params.get('error');

            if (errorParam) {
                setError('Google authentication was cancelled or failed.');
                toast.error('Google authentication failed');
                setTimeout(() => navigate('/login'), 2000);
                return;
            }

            if (!code) {
                setError('No authorization code received from Google.');
                toast.error('Authentication failed');
                setTimeout(() => navigate('/login'), 2000);
                return;
            }

            try {
                // Send the authorization code to your backend
                const formData = new FormData();
                formData.append('code', code);
                formData.append('redirect_uri', process.env.REACT_APP_GOOGLE_REDIRECT_URI || `${window.location.origin}/auth/google/callback`);

                const endpoint = state === 'signup'
                    ? '/api/customer/auth/google/signup'
                    : '/api/customer/auth/google/login';

                const response = await http.post(endpoint, formData);

                const token = response?.data?.data?.token || response?.data?.token;

                if (token) {
                    localStorage.setItem('authToken', token);

                    // Fetch user profile
                    const profileResponse = await http.get('/api/customer/profile');
                    const profile = profileResponse?.data?.data || profileResponse?.data;

                    if (profile) {
                        localStorage.setItem('userData', JSON.stringify(profile));
                        toast.success(`${state === 'signup' ? 'Signed up' : 'Logged in'} with Google successfully!`);
                        navigate('/');
                    } else {
                        throw new Error('Failed to fetch user profile');
                    }
                } else {
                    throw new Error('No token received from server');
                }
            } catch (err) {
                console.error('Google auth error:', err);
                const errorMsg = err?.response?.data?.message || 'Google authentication failed. Please try again.';
                setError(errorMsg);
                toast.error(errorMsg);
                setTimeout(() => navigate('/login'), 2000);
            }
        };

        handleGoogleCallback();
    }, [location, navigate]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '20px',
            textAlign: 'center'
        }}>
            {error ? (
                <>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
                    <h2 style={{ color: '#e74c3c', marginBottom: '10px' }}>Authentication Failed</h2>
                    <p style={{ color: '#666' }}>{error}</p>
                    <p style={{ color: '#999', fontSize: '14px', marginTop: '20px' }}>Redirecting to login...</p>
                </>
            ) : (
                <>
                    <div className="spinner" style={{
                        width: '50px',
                        height: '50px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #FF6B3D',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px'
                    }} />
                    <h2 style={{ color: '#333', marginBottom: '10px' }}>Authenticating with Google...</h2>
                    <p style={{ color: '#666' }}>Please wait while we complete your authentication.</p>
                    <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
                </>
            )}
        </div>
    );
};

export default GoogleCallback;
